import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="sw-container" style={{ padding: 'var(--sp-12) var(--sp-3)' }}>
        <Link to="/" style={{ display: 'inline-flex', marginBottom: 'var(--sp-6)', color: 'var(--primary-light)', fontWeight: 700 }}>
            ← Back to Home
        </Link>
        <div className="sw-glass" style={{ padding: 'var(--sp-10)', maxWidth: '900px', margin: '0 auto', color: 'var(--text-soft)' }}>
            <h1 style={{ marginBottom: 'var(--sp-2)', color: 'var(--text)' }}>Privacy Policy</h1>
            <span style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: 'var(--sp-8)', display: 'block' }}>
                Last Updated: August 17, 2026
            </span>

            <section style={{ marginBottom: 'var(--sp-8)' }}>
                <p>Your privacy matters to us. This policy explains how Swiftech collects, uses, protects, and manages information when you use our website and digital services.</p>
            </section>

            <section style={{ marginBottom: 'var(--sp-8)' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--primary-light)', borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>1. Information We Collect</h2>
                <p>We may collect information that you voluntarily provide, technical information generated when you use our website, and information associated with services you request.</p>
                <h3 style={{ fontSize: '1.1rem', margin: 'var(--sp-4) 0 var(--sp-2)', color: 'var(--text)' }}>Information You Provide</h3>
                <ul style={{ marginLeft: 'var(--sp-4)', listStyle: 'disc', marginBottom: 'var(--sp-4)' }}>
                    <li>Full name, Email address, and Telephone number.</li>
                    <li>Business name and business type.</li>
                    <li>Website, application, software, or project requirements.</li>
                    <li>Messages submitted through contact forms.</li>
                    <li>Information provided when requesting a website template or customization.</li>
                </ul>
                <h3 style={{ fontSize: '1.1rem', margin: 'var(--sp-4) 0 var(--sp-2)', color: 'var(--text)' }}>Automatically Collected Information</h3>
                <p>We may automatically process technical information such as your IP address, browser type, device type, operating system, pages visited, and visit duration to improve user experience.</p>
            </section>

            <section style={{ marginBottom: 'var(--sp-8)' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--primary-light)', borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>2. How We Use Your Information</h2>
                <ul style={{ marginLeft: 'var(--sp-4)', listStyle: 'disc', marginBottom: 'var(--sp-4)' }}>
                    <li>Respond to inquiries and communicate about projects.</li>
                    <li>Prepare quotations and provide requested services.</li>
                    <li>Develop and customize digital solutions.</li>
                    <li>Improve our website performance and security.</li>
                    <li>Protect the rights, property, and safety of Swiftech and our customers.</li>
                </ul>
            </section>

            <section style={{ marginBottom: 'var(--sp-8)' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--primary-light)', borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>3. Cookies and Analytics</h2>
                <p>Swiftech may use cookies and similar technologies to maintain sessions, remember preferences, and monitor website performance via analytics tools.</p>
            </section>

            <section style={{ marginBottom: 'var(--sp-8)' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--primary-light)', borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>4. Data Sharing and Security</h2>
                <p>We do not sell your personal information. We may share information with trusted service providers who help us operate our infrastructure (e.g., Firebase, hosting providers) or when required by law.</p>
                <p>We take reasonable technical and organizational measures to protect your information, including access controls, encryption, and secure cloud infrastructure.</p>
            </section>

            <section style={{ background: 'rgba(99, 102, 241, 0.05)', padding: 'var(--sp-6)', borderRadius: 'var(--radius-md)', border: '1px solid rgba(99, 102, 241, 0.2)' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--primary-light)' }}>Contact Us</h2>
                <p>If you have questions regarding this Privacy Policy, please contact us:</p>
                <p>
                    <strong>Phone:</strong> <a href="tel:+96176637752" style={{ color: 'var(--primary-light)' }}>+961 76 637 752</a><br />
                    <strong>Email:</strong> <a href="mailto:swiftechlb@gmail.com" style={{ color: 'var(--primary-light)' }}>swiftechlb@gmail.com</a>
                </p>
            </section>
        </div>
    </div>
  );
};

export default PrivacyPolicy;
